import React from 'react';
import { cn } from '@utils/classNames';

interface SidebarPlanCardProps {
  planDisplayName: string;
  shouldShowUpgrade: boolean;
  renewalText: string | null;
  onUpgrade: () => void;
  className?: string;
}

export const SidebarPlanCard: React.FC<SidebarPlanCardProps> = ({
  planDisplayName,
  shouldShowUpgrade,
  renewalText,
  onUpgrade,
  className,
}) => (
  <div
    className={cn(
      'p-3.5 rounded-xl bg-white/[0.06] border border-white/[0.08] transition-colors hover:bg-white/[0.08]',
      className
    )}
  >
    <div className="relative">
      <h3 className="font-dela text-xs font-medium text-white/90 uppercase tracking-wider mb-1">
        Your Plan
      </h3>
      <p className="font-codec font-bold text-xs text-white/80 mb-2">{planDisplayName}</p>
      {shouldShowUpgrade && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            onUpgrade();
          }}
          className="block w-full h-8 rounded-lg bg-primary text-black font-codec font-bold text-sm hover:opacity-90 transition-opacity"
        >
          <span className="flex items-center justify-center h-full">Upgrade</span>
        </button>
      )}
      {renewalText && (
        <p className="mt-2 font-inter text-[10px] text-white/50">{renewalText}</p>
      )}
    </div>
  </div>
);
